import { render } from "./TemplatesWhatsapp.vue?vue&type=template&id=ce3f2158&scoped=true&ts=true"
import script from "./TemplatesWhatsapp.vue?vue&type=script&lang=ts"
export * from "./TemplatesWhatsapp.vue?vue&type=script&lang=ts"

import "./TemplatesWhatsapp.vue?vue&type=style&index=0&id=ce3f2158&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3f2158"]])

export default __exports__